import { getPttTcss } from './../request/mosso'
import { reportDmpBtn } from './../request/dmp'
import { publicParams } from './../store/index'

/**
 * dmp上报列表指令
 * @param {*} el 
 * @param {*} binding 
 */

export default function vMosso (el, binding) {
    el.addEventListener('click', function mossoClickHandler(e) {
        let arr = typeof binding.value === 'string' ? JSON.parse(binding.value.replace(/\'/g,'"')) : binding.value
        getPttTcss().then(() => {
            window.PTTSendClick(arr[0], arr[1], arr[2]);
        })
        
        // 同步上报dmp
        if(publicParams.mosso_to_dmp) reportDmpBtn(arr)
    }, false)
}